import ActiveSortDown from 'src/assets/img/voicealbum/sort/active_sort_down.png'
import ActiveSortUp from 'src/assets/img/voicealbum/sort/active_sort_up.png'
import DeactiveSortUp from 'src/assets/img/voicealbum/sort/deactive_sort_up.png'
import DeactiveSortDown from 'src/assets/img/voicealbum/sort/deactive_sort_down.png'

export const sortDirectionOptions = [
  {
    activeIcon: ActiveSortUp,
    deactiveIcon: DeactiveSortUp,
    label: '古い順に並び替え',
    direction: 'asc'
  },
  {
    activeIcon: ActiveSortDown,
    deactiveIcon: DeactiveSortDown,
    label: '新しい順に並べ替え',
    direction: 'desc'
  }
]
